export default __webpack_public_path__ + "static/media/new6.790e0701.jpg";